import { useEffect, useState } from 'react'
import { Button, Dialogue } from '~/components'
import Input from '~/components/Input/Input'
import Typography, {
  TypographyTag,
  TypographyVariant,
} from '~/components/Typography'
import styles from './CreateCustomerListDialogue.module.css'
import { CreateCustomerListDialogueProps } from './CreateCustomerListDialogue.types'

export const CreateCustomerListDialogue = ({
  open = false,
  title,
  label,
  confirmButtonText,
  defaultValue,
  onClose,
  confirmAction,
}: CreateCustomerListDialogueProps) => {
  const [loading, setLoading] = useState(false)
  const [listName, setListName] = useState('')

  const handleConfirm = async () => {
    if (!confirmAction) {
      return
    }

    setLoading(true)
    const result = await confirmAction(listName)

    setLoading(false)
    if (result) {
      onClose?.()
    }
  }

  useEffect(() => {
    setListName(defaultValue || '')
  }, [defaultValue, open])

  return (
    <Dialogue
      visible={open}
      onCancel={onClose}
      onOk={onClose}
      wrapperClassName={styles.root}>
      <div>
        <Typography tag={TypographyTag.p} variant={TypographyVariant.Heading6}>
          {title}
        </Typography>
        <div className='pt-6 pb-8'>
          <Input
            name='list-name'
            label={label}
            placeholder='List name'
            value={listName || ''}
            onChange={(v) => {
              return setListName(v)
            }}
          />
        </div>
        <div className='w-full flex justify-end gap-2'>
          <Button
            status='secondary'
            onClick={onClose}
            disabled={loading}
            style={{
              '--btn-size-md-padding': '14px 16px',
            }}>
            Cancel
          </Button>

          <Button
            disabled={loading || !listName || defaultValue === listName}
            loading={loading}
            onClick={() => {
              return handleConfirm()
            }}
            style={{
              '--btn-size-md-padding': '14px 16px',
            }}>
            {confirmButtonText}
          </Button>
        </div>
      </div>
    </Dialogue>
  )
}
